import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { SUPPORT_USER_CATEGORIES_QUERY_KEY } from "../../../constants/queryKeys";

export const useUserCategoriesWithRules = (userId) => {
  return useQuery({
    queryKey: [SUPPORT_USER_CATEGORIES_QUERY_KEY, userId],
    queryFn: async () => makeApiRequest({
      endpoint: `/api/support/user-categories/${userId}`,
      method: "GET"
    }),
    enabled: !!userId
  });
};
